import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MetricsService } from '@gms/monitoring-api';
import {
  getMetricCharts,
  getMetricChartsSuccess,
  getMetricChartsError,
  getMetricData,
  getMetricDataSuccess,
  getMetricDataError,
  getMetricDefinitions,
  getMetricDefinitionsSuccess,
  getMetricDefinitionsError,
} from 'app/store/app-monitoring/app-monitoring.actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppMonitoringEffects {
  constructor(
    private _actions$: Actions,
    private _metricService: MetricsService
  ) {}

  getMetricCharts$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getMetricCharts),
      switchMap(() =>
        this._metricService.getMetricCharts().pipe(
          map((metricCharts) => getMetricChartsSuccess({ metricCharts })),
          catchError((error) => of(getMetricChartsError({ error })))
        )
      )
    )
  );

  getMetricData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getMetricData),
      switchMap((action) =>
        this._metricService.getMetricData(action.id, action.startTime, action.endTime).pipe(
          map((chartData) => getMetricDataSuccess({ chartData })),
          catchError((error) => of(getMetricDataError({ error })))
        )
      )
    )
  );

  getMetricDefinitions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getMetricDefinitions),
      switchMap(() =>
        this._metricService.getMetricDefinitions().pipe(
          map((metricDefinitions) => getMetricDefinitionsSuccess({ metricDefinitions })),
          catchError((error) => of(getMetricDefinitionsError({ error })))
        )
      )
    )
  );
}
